import { Tabs, TabsProps } from '@mantine/core';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useEffectOnce } from 'react-use';

import { useConfirmNavigation } from '@portals/framework';

import { Design } from './tool-panel/tabs/design/Design';
import { Domain } from './tool-panel/tabs/domain/Domain';
import { BrandingTabEnum } from './tool-panel/types';
import { useBrandingContext } from '../../branding.context';

const getInitialTabFromSearchParams = (
  location: ReturnType<typeof useHistory>['location']
): BrandingTabEnum => {
  const urlSearchParams = new URLSearchParams(location.search);
  const tab = urlSearchParams.get('tab');

  if (!tab) return BrandingTabEnum.Design;

  switch (tab) {
    case 'domain':
      return BrandingTabEnum.Domain;
    default:
      return BrandingTabEnum.Design;
  }
};

export function CustomerPortalForm() {
  const { location, replace } = useHistory();
  const initialTab = getInitialTabFromSearchParams(location);
  const { isPristine, revertChanges } = useBrandingContext();

  const [selectedTab, setSelectedTab] = useState<BrandingTabEnum>(initialTab);

  useEffectOnce(() => {
    // Search URL used only for setting initial tab, removing after render
    if (initialTab) {
      replace('/branding/customer-portal');
    }
  });

  useConfirmNavigation({
    isActive: !isPristine,
    confirmationModal: {
      title: 'Leave page without saving?',
      description:
        'You are about to leave the white-label progress and discard all your work. Are you sure?',
      confirmationLabel: 'Discard and Leave',
      cancelLabel: 'Keep Editing',
    },
    onConfirm: revertChanges,
  });

  return (
    <Tabs
      value={selectedTab}
      onTabChange={(tab: BrandingTabEnum) => setSelectedTab(tab)}
      styles={tabsStyles}
    >
      <Tabs.List grow>
        <Tabs.Tab value={BrandingTabEnum.Design} py="sm">
          Design
        </Tabs.Tab>
        <Tabs.Tab value={BrandingTabEnum.Domain} py="sm">
          Domain
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value={BrandingTabEnum.Design}>
        <Design />
      </Tabs.Panel>

      <Tabs.Panel value={BrandingTabEnum.Domain}>
        <Domain />
      </Tabs.Panel>
    </Tabs>
  );
}

const tabsStyles: TabsProps['styles'] = () => ({
  root: {
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'max-content 1fr',
  },
  panel: {
    flexGrow: 1,
  },
});
